import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC8KybozTI6ipKv5kKwodcmHi4FmutYGhA",
  authDomain: "eshaafi-patientapp.firebaseapp.com",
  databaseURL: "https://eshaafi-patientapp-default-rtdb.firebaseio.com",
  projectId: "eshaafi-patientapp",
  storageBucket: "eshaafi-patientapp.appspot.com",
  messagingSenderId: "651637779464",
  appId: "1:651637779464:web:a5924f75a2679126b8f5bd",
  measurementId: "G-12TSTRGVRQ",
};
// const firebaseConfig = {
//   apiKey: "AIzaSyCI9NHAl2zwkd6T5DSHn-Veicx2V1omv5c",
//   authDomain: "eshaafi-196c4.firebaseapp.com",
//   projectId: "eshaafi-196c4",
//   storageBucket: "eshaafi-196c4.appspot.com",
//   messagingSenderId: "59636761923",
//   appId: "1:59636761923:web:d1654f6c555f3dd7dadbf6",
//   measurementId: "G-29J95HTBL6",
// };
// initializing the app
const firebaseApp = initializeApp(firebaseConfig, "adminPanel");
// getting messages
const messaging = getMessaging(firebaseApp);

/**
 * Get FCM device token
 * @param {function} setTokenFound - Callback to set token status
 * @returns {Promise<string|null>} Device token
 */
export const gettoken = async (setTokenFound) => {
  try {
    // Check if notifications are supported
    if (!("Notification" in window)) {
      console.warn("Notifications not supported");
      setTokenFound?.(false);
      return null;
    }

    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission denied");
      setTokenFound?.(false);
      return null;
    }

    // Get the token from Firebase
    const currentToken = await getToken(messaging, {
      vapidKey:
        // "BGjIWfnyirp_0V3lfH5BzOkhU6Ic12SmSw9OAwfNzgj-4kd5szIzhfPQinNoLIJ7gp50LrDk8fORRSN8WVz_Im0",
        "BPGO6oIB5SgKIPvqtRJWDJXC3laLFVlRbnARGjdgU03sQsnHLQxyhlE_W1OFNG0Qa8KO0zggGDQxKSefIZg9kGU",
    });

    if (currentToken) {
      // Store token in localStorage (original functionality)
      localStorage.setItem("deviceToken", JSON.stringify(currentToken));
      setTokenFound?.(true);
      return currentToken;
    } else {
      console.log("No registration token available");
      setTokenFound?.(false);
      return null;
    }
  } catch (err) {
    console.error("Error retrieving token:", err);
    setTokenFound?.(false);
    return null;
  }
};

/**
 * Get stored device token from localStorage
 * @returns {string|null} Stored device token
 */
export const getStoredDeviceToken = () => {
  try {
    const token = localStorage.getItem("deviceToken");
    return token ? JSON.parse(token) : null;
  } catch (error) {
    console.error("Error reading token from storage:", error);
    return null;
  }
};

/**
 * Initialize token and make it available globally
 * @param {function} dispatch - Redux dispatch function
 * @returns {Promise<string|null>} Device token
 */
export const initializeToken = async (dispatch) => {
  // First try to get existing token from localStorage
  let token = getStoredDeviceToken();

  // If no token found, get new token
  if (!token) {
    token = await gettoken((found) => {
      if (found && dispatch) {
        dispatch({
          type: "SET_DEVICE_TOKEN",
          payload: localStorage.getItem("deviceToken"),
        });
      }
    });
  }

  // If we have a token and dispatch is available, update Redux
  if (token && dispatch) {
    dispatch({
      type: "SET_DEVICE_TOKEN",
      payload: localStorage.getItem("deviceToken"),
    });
  }

  return token;
};

/**
 * Listen for incoming messages
 * @returns {Promise<object>} Message payload
 */
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

// Export messaging instance for other uses
export { messaging };
